module.exports = __webpack_public_path__ + "static/media/hook-n-ladder.f4f39f37.mp4";